export default __webpack_public_path__ + "static/media/menuLogo.c132e03d.png";